export default "<div>\n    <h2>{{this.data.chart.tableName}}</h2>\n\n    <canvas #canvas id=\"{{this.data.chart.fullDataTableName}}\"></canvas>\n</div>"